var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"color":"error","outlined":""}},[_c('div',{staticClass:"text-body-1"},[_vm._v(" Antes de realizar un nuevo pedido, da instrucciones a tu BACKORDER disponible ")]),_c('v-btn',{staticClass:"red-button mt-2",attrs:{"to":{ name: 'HistoryOrders', params: { scrollTo: 'backorders' } }}},[_vm._v(" Ir a backorders ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }